$(document).ready(function () {
  // collectionItemEqual();
  $(".qv-main_images").on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      console.log(slick, event);
    }
  );

  setTimeout(function () {
    var hh =
      parseFloat($(".atoms-submenu").height()) +
      parseFloat($('[data-section-type="header"]').height()) +
      30;
    $(
      ".collhandle--all .promo-grid--space-top, .collhandle--all .product-banner"
    ).css({ marginTop: hh - 15, paddingTop: "0" });
    $(
      ".default-coll-template .promo-grid--space-top, .default-coll-template .product-banner"
    ).css({
      marginTop: hh - parseFloat($(".atoms-submenu").height()),
      paddingTop: "0",
    });
  }, 0);

  $(".video-section-wrapper").click(function () {
    var video = $(this).find("video").get(0);
    if (video.paused) {
      video.play();
      $(this).find(".video-overlay").hide();
    } else {
      video.pause();
      $(this).find(".video-overlay").show();
    }
  });

  try {
    $(".product_slider__js").each(function () {
      var $slider = $(this),
        options = JSON.parse($slider.attr("data-options"));
      $slider.slick(options);
    });
  } catch (error) {}

  setTimeout(function () {
    window.manageFreeGift();
  }, 2000);

  document.addEventListener("ajaxProduct:added", function (event) {
    console.log("ajaxProduct:added:", event);
    setTimeout(function () {
      window.manageFreeGift();
    }, 1500);
  });

  document.addEventListener("cart:updated", function (event) {
    console.log("Cart updated:", event.detail.cart);
    setTimeout(function () {
      window.manageFreeGift();
    }, 1500);
  });

  $(document).on("click", ".qv-btn", function (e) {
    e.preventDefault();
    var $el = $(this),
      url = $el.attr("href");
    $("#qv--content").addClass("qv-loading");
    qv_modal();
    fetch(`${url}?section_id=quick-view`)
      .then((res) => res.text())
      .then((html) => {
        // console.log(html);
        var qv_html = $(html).find("#quick-view--holder").html();
        $("#qv--content").removeClass("qv-loading").html(qv_html);
        initSlick();
      });
  });

  $(document).on("click", ".qv-qty-adjust", function () {
    var $el = $(this),
      $wrap = $el.closest(".qv-qty-wrap"),
      $input = $wrap.find(".qv-qty-input"),
      val = parseInt($input.val());
    if ($el.hasClass("plus")) {
      val = val + 1;
    } else {
      if (val > 1) {
        val = val - 1;
      }
    }
    $input.val(val);
  });

  $(window).on("click", function (e) {
    // e.target.id === "quick-view-modal__wrap" && qv_modal(false);
  });

  $(document).on("click", ".qv-thumbs .qv-thumb", function () {
    var $el = $(this),
      index = $el.data("index");
    $(".qv-thumbs .qv-thumb").removeClass("active");
    $el.addClass("active");
    $(".qv-main_images").slick("slickGoTo", index);
  });

  $(document).on("submit", ".qv-prd--form", function (e) {
    e.preventDefault();
    var $from = $(this);
    addToCart($from);
  });

  $(document).on("click", ".add_bundle", function () {
    var $el = $(this),
      id = $el.attr("data-id") || null,
      data = [];
    if (id) {
      $el.addClass("loading");
      data.push({
        id: id,
        quantity: 1,
        properties: { __source: "bundle" },
      });
      multipleATC(data, $el);
    }
  });

  $(document).on("click", ".add_fbt_item", function () {
    var $el = $(this),
      id = $el.attr("data-id") || null,
      data = [];
    if (id) {
      $el.addClass("loading");
      data.push({
        id: id,
        quantity: 1,
        properties: null,
      });
      multipleATC(data, $el);
    }
  });
}); // ready

// function collectionItemEqual() {
//   $(".shopify-section").each(function () {
//     let $el = $(this), maxHeightTitle = 0, maxHeightPrice = 0;
//     $el.find(".grid-product__title--body").each(function () {
//       if ($(this).height() > maxHeightTitle) maxHeightTitle = $(this).height();
//     });
//     $el.find(".grid-product__title--body").height(
//       maxHeightTitle
//     );
//     $el.find(".grid-product__price").each(function () {
//       if ($(this).height() > maxHeightPrice) maxHeightPrice = $(this).height();
//     });
//     $el.find(".grid-product__price").height(maxHeightPrice);
//   });
// }

function qv_modal(open = true) {
  var $qv_modal = $("#quick-view-modal__wrap");
  if (open) {
    $qv_modal.fadeIn();
    $("body").addClass("qv_open");
  } else {
    $qv_modal.fadeOut(function () {
      $("body").removeClass("qv_open");
      $("#qv--content").html("");
    });
  }
}

function initSlick() {
  $(".qv-main_images").on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var index = $(slick.$slider)
        .find(".slick-current.slick-active")
        .data("index");
      $(".qv-thumbs .qv-thumb").removeClass("active");
      $(`.qv-thumbs .qv-thumb[data-index="${index}"]`).addClass("active");
    }
  );

  $(".qv-main_images").slick({
    arrows: false,
    adaptiveHeight: true,
  });
  // $(".qv-thumbs").slick({
  //   slidesToShow: 10,
  //   vertical: true,
  //   verticalSwiping: true,
  //   arrows: false,
  //   swipeToSlide: true,
  //   focusOnSelect: true,
  // });
}

function addToCart($form, drawer = false) {
  var $btn = $form.find(`[type="submit"]`);
  if ($btn.hasClass("btn--loading")) {
    return;
  }
  $btn.prop("disabled", true).addClass("btn--loading");
  setTimeout(function () {
    jQuery.ajax({
      type: "POST",
      url: window.Shopify.routes.root + "cart/add.js",
      async: false,
      data: $form.serialize(),
      dataType: "json",
      success: function () {
        if (drawer) {
          document.dispatchEvent(
            new Event("ajaxProduct:added", { bubbles: true })
          );
        } else {
          document.dispatchEvent(
            new Event("ajaxProduct:addedDrawerClose", { bubbles: true })
          );
        }
        $btn.prop("disabled", false).removeClass("btn--loading");
      },
      error: function (error) {
        console.log("Error:", error);
        $btn.prop("disabled", false).removeClass("btn--loading");
      },
    });
  }, 0);
}
// var fgload = false;
window.manageFreeGift = () => {
  // console.log(fgload, "fglllll");
  // if (fgload) return;
  // fgload = false;
  // theme.cart.getCart().then((cart) => {
  // fgload = false;
  var $el = $(".fg__wrapper");
  // console.log(cart, "call freegift", window.free_gift, $el);
  if (!window.free_gift?.enable || $el.length <= 0) return;
  var fg = JSON.parse($el.attr("data-fg"));
  console.log("call freegift inn", fg);
  if (fg.action == "do_nothing") {
    return;
  } else if (fg.action == "do_add") {
    let timespan = new Date().getTime(),
      items = [];
    items.push({
      id: window.free_gift.variant_id,
      quantity: 1,
      properties: {
        __freegift: true,
        __timespan: timespan,
        __source: "freegift",
      },
    });
    multipleATC(items);
  } else {
    removeMultiple([fg.gift_key]);
  }
  // });
};

function multipleATC(item_array, $btn = null) {
  var items = [];
  // console.log(item_array.length, item_array);
  item_array.forEach((item) => {
    myObj = {
      id: item.id,
      quantity: item.quantity,
      properties: item.properties,
    };
    items.push(myObj);
  });

  let formData = {
    items: items,
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (response.ok) {
        console.log(response);
      }
      return response.json();
    })
    .then((items) => {
      if ($btn) {
        $btn.removeClass("loading");
      }
      document.dispatchEvent(new Event("ajaxProduct:added", { bubbles: true }));
      console.log(items);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function removeMultiple(ids, $btn) {
  let updates = {};
  ids.forEach((id) => {
    updates[id] = 0;
  });
  // console.log(ids);
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
    .then((response) => {
      if ($btn) {
        $btn.removeClass("loading");
      }
      document.dispatchEvent(new Event("ajaxProduct:added", { bubbles: true }));
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
